import { HandleSubMenuToggleParams } from '@/components/PageHeader/components/utils/renderThirdLevelMenu.model'

/**
 * Handles the toggle functionality for submenus.
 *
 * @param e - The event object.
 * @param levelRef - The reference to the current menu level.
 * @param params - Utility functions and references required for submenu handling.
 */
export const handleSubMenuToggle = (
  e: any,
  levelRef: any,
  {
    removeEmptyParentMenus,
    handleMenuOverlay,
    removeSubMenuVisibility,
    removeParentMenuArrows,
    setFirstSubMenuSelected,
    listMainMenu,
    styles,
  }: HandleSubMenuToggleParams
): void => {
  const getSubMenu: HTMLElement | null = document.querySelector(`.subMenu`)
  const menuLinks = e.currentTarget.nextElementSibling.querySelectorAll('li')
  const getParentMenu: NodeListOf<HTMLElement> =
    document.querySelectorAll(`.grandSubMenu`)
  const level1Links = levelRef
  const parentMenu = e.currentTarget.closest('li')
  const siblingList = level1Links.current.nextElementSibling

  for (const menuLink of menuLinks) {
    menuLink.classList.remove(styles.selected)
  }

  removeEmptyParentMenus(getParentMenu)

  if (siblingList) {
    e.preventDefault()
    if (getSubMenu) getSubMenu.style.height = 'auto'
    parentMenu.classList.toggle(styles.upArrow)
    siblingList.classList.toggle(styles.isVisible)

    const mainMenu: HTMLElement | null = document.querySelector(`.showOverlay`)
    const menuList: NodeListOf<HTMLElement> =
      listMainMenu.current?.querySelectorAll('li') ||
      document.querySelectorAll('li')
    const currentParentMenu = e.currentTarget.closest('li')

    if (mainMenu && currentParentMenu) {
      handleMenuOverlay(currentParentMenu, mainMenu)
      removeSubMenuVisibility(
        document.querySelectorAll(`.subMenu`),
        siblingList
      )
      removeParentMenuArrows(menuList, currentParentMenu)
      setFirstSubMenuSelected(menuLinks)
    }
  }
}
